<template>
  <div class="carro--sugerido">
    <div @click="openCarro" class="basket">
      <i class="entypo entypo-basket"></i>
      <div class="cantidad__items">
        <small class="cantidad__items--numero text-white text-center">{{carro.length}}</small>
      </div>
    </div>
    <vuestic-modal :large="true" ref="modalCarro" transition="fade">
      <div slot="title">CARRO DE COMPRA</div>
      <table class="table table-bordered">
        <thead class="blue-head">
        <tr>
          <th>#</th>
          <th>CODIGO</th>
          <th>CODIGO PROVEEDOR</th>
          <th>DESCRIPCION</th>
          <th>PROVEEDOR</th>
          <th>STOCK</th>
          <th>CANTIDAD COMPRAR</th>
          <th>COSTO</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="carro.length === 0">
          <td colspan="8">Nada para mostrar...</td>
        </tr>
        <tr v-else v-for="(item, index) in carro">
          <td>{{index + 1}}</td>
          <td>{{item.codigo}}</td>
          <td>{{item.codigo_proveedor}}</td>
          <td>{{item.descripcion | upper}}</td>
          <td>{{item.proveedor | upper}}</td>
          <td>{{item.stock}}</td>
          <td>{{item.cantidad_a_comprar}}</td>
          <td>{{item.costo_pactado}}</td>
          <td><i class="fa fa-remove" @click="deleteItem(index)"></i></td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td colspan="7"><b>Total</b></td>
          <td>{{total}}</td>
        </tr>
        </tfoot>
      </table>
      <div v-if="carro.length >= 1" class="pull-right">
        <button class="btn btn-success btn-micro" @click="generate">Generar Compra</button>
        <button class="btn btn-danger btn-micro" @click="limpiarCarro">Vaciar Carro</button>
      </div>
    </vuestic-modal>
  </div>


</template>

<script>
  import {mapGetters, mapActions} from "vuex"
  import VuesticModal from "../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";

  export default {
    name: "SugeridoCompraCarro",
    components: {VuesticModal},
    computed: {
      ...mapGetters({
        carro: "sugeridoCompra/productosCarro"
      }),
      total() {
        return this.carro.reduce((a, b) => a.costo_pactado + b.costo_pactado)
      }
    },
    methods: {
      ...mapActions({
        deleteItem: "sugeridoCompra/removeItem",
        clearCarro: "sugeridoCompra/removeAll",
        generarOrdenCompra: "sugeridoCompra/generarOrdenCompra"
      }),
      limpiarCarro() {
        this.clearCarro()
        if (this.carro.length === 0)
          this.$refs.modalCarro.close()

      },
      openCarro() {
        this.$refs.modalCarro.open()
      },
      generate() {
        this.generarOrdenCompra()
        this.$refs.modalCarro.close()
      }
    }
  }
</script>

<style scoped lang="scss">

  .basket {


    border-radius: 50%;
    border: 2px solid white;
    width: 50px;
    height: 50px;
    margin-right: 10px;
    position: relative;
    cursor: pointer;

    &:hover {
      background-color: #0fb300;
      transition: all linear 300ms;
    }


    & i {
      color: white;
      position: absolute;
      left: 11px;
      top: 6px;
      margin-left: auto;
      margin-right: auto;
      font-size: 22px;
    }

    .cantidad__items {
      background-color: #0fb300;
      width: 20px;
      height: 20px;
      position: absolute;
      border-radius: 50%;
      top: -3px;
      left: 33px;

      &--numero {
        font-size: 12px;
        font-weight: bold;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 1px;
      }
    }
  }

  .blue-head {
    background-color: $color-corporativo !important;

    tr {
      color: white !important;

      th {
        border: none;
      }
    }
  }

</style>
